import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FilledInput } from '@material-ui/core';
import { Button } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";

import useStyle from './style';

const FileUploader = ({ value, onClear, ...props}) => {

    const classes = useStyle();
    const inputFile = useRef();

    const placeHolder = () =>  value ?? props.label;
    const placeHolderClass = () => props.error ? 'error' : (value ? 'filled' : '');
    const handleAttachButton = () => inputFile && inputFile.current.click();

    const handleAttachFile = event => {
        if (event.target.files && event.target.files.length) {
            const file = event.target.files[0];
            props.onChange && props.onChange(file);
        }
    }

    const removeFile = async () => {
        const innerInput = inputFile.current.children[0];
        innerInput.value = null;        
        innerInput.type = 'text';
        innerInput.type = 'file';
        onClear && onClear();
    };

    return <>
        <div className={classes.root}>
            <div>
                <label className={placeHolderClass()}>
                    <span>{placeHolder()}</span>
                    <FilledInput
                        ref={inputFile}
                        onChange={handleAttachFile}
                        style={{ display: 'none' }} type="file" />
                </label>
                {props.children}
                {value && (
                    <IconButton
                        className={classes.trashButton}
                        onClick={removeFile}
                    >
                        <DeleteIcon fontSize="small" color="error" />
                    </IconButton>
                )}
            </div>
            <Button
                onClick={handleAttachButton}
                variant="contained"
                color="primary"
                size="large"
            >Anexar</Button>        
        </div>
    </>
}

FileUploader.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
}

export default FileUploader;